import React from 'react'
import Styled from 'styled-components'
import { lighten, darken } from 'polished'
import get from 'lodash/get'

import Loader from 'components/Loader'
import Icon from 'components/Icon'

const getColor = (props) => {
  if (props.variant === 'white') {
    return props.theme.colors.gray.shade100
  }

  if (props.outline) {
    return get(props.theme.colors, props.variant || 'primary.shade400')
  }

  return props.theme.colors.white
}

const getBackgroundColor = (props) => {
  if (props.outline) {
    return props.theme.colors.white
  }

  return get(props.theme.colors, props.variant || 'primary.shade400')
}

const getBackgroundColorHover = (props) => {
  return lighten(0.05, getBackgroundColor(props))
}

const getBackgroundColorActive = (props) => {
  return darken(0.05, getBackgroundColor(props))
}

const getBorderColor = (props) => {
  if (props.variant === 'white') {
    return props.theme.colors.gray.shade50
  }

  return get(props.theme.colors, props.variant || 'primary.shade400')
}

const getBorderColorHover = (props) => {
  if (props.variant === 'white') {
    return getBorderColor(props)
  }

  return lighten(0.05, getBorderColor(props))
}

const getBorderColorActive = (props) => {
  return darken(0.05, getBorderColor(props))
}

const getLoaderVariant = (props) => {
  if (props.outline) {
    return props.variant
  }

  return 'white'
}

const HideableLoader = Styled.span`
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  visibility: ${props => (props.hide ? 'hidden' : 'visible')};
  font-size: 1.25em;
  line-height: 1;
`

const HideableCheckmark = Styled.span`
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  visibility: ${props => (props.hide ? 'hidden' : 'visible')};
  font-size: 1.25em;
  line-height: 1;
`

const HideableLabel = Styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  visibility: ${props => (props.hide ? 'hidden' : 'visible')};
`

const Label = Styled.div`
  font-size: 0.8em;

  ${props => props.icon && `
    padding-left: 0.5em;
  `}
`

const Button = Styled.button.attrs(props => ({
  type: props.type || 'button'
}))`
  display: block;
  position: relative;
  font-family: ${props => props.theme.fonts.regular};
  font-weight: 600;
  letter-spacing: 1.5px;
  background-color: ${getBackgroundColor};
  color: ${getColor};
  border-radius: ${props => props.theme.radius};
  padding: 0 2em;
  height: 2.5em;
  line-height: 2.5em;
  border: 1px solid ${getBorderColor};;
  box-shadow: 0 0.25rem 1rem 0 rgba(51, 51, 51, 0.05);
  cursor: pointer;
  transition: 300ms;
  text-transform: uppercase;
  text-decoration: none;
  outline: none;

  ${props => props.disabled && `
    cursor: not-allowed;
    opacity: 0.5;
  `}

  ${props => props.disabledSilently && `
    cursor: not-allowed;
  `}

  ${props => props.expand && `
    width: 100%;
    padding: 0;
  `}

  ${props => props.compact && `
    padding: 0 1em;
  `}

  &:hover, &:focus {
    background: ${props => getBackgroundColorHover(props)};
    border-color: ${props => getBorderColorHover(props)};
  }

  &:active {
    background: ${props => getBackgroundColorActive(props)};
    border-color: ${props => getBorderColorActive(props)};
  }
`

export default ({ loading, success, icon, children, ...props }) => (
  <Button {...props}>
    <HideableLoader hide={!loading}>
      <Loader variant={getLoaderVariant(props)} />
    </HideableLoader>

    <HideableCheckmark hide={!success}>
      <Icon liga="check" />
    </HideableCheckmark>

    <HideableLabel hide={loading || success}>
      <Icon liga={icon} />

      {children &&
        <Label icon={icon}>{children}</Label>
      }
    </HideableLabel>
  </Button>
)



// WEBPACK FOOTER //
// ./src/components/Button/index.js